module.exports = __webpack_public_path__ + "static/media/Land.54db9b9c.jpg";